//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../../../library/umum";

export default {
  data() {
    return {
      Pangkat:[{Pangkat:'Pangkat/Golongan 1'},{Pangkat:'Pangkat/Golongan 2'}],
      form: {
        id: "",
        agama:'',
        agama_uraian:'',
        createdAt:'',
        createdBy:'',
        file:'',
        fileThumb:'',
        id:'',
        jabatan:'',
        nama:'',
        nip:'',
        pangkat_gol:'',
        pendidikan:'',
        pendidikan_uraian:'',
        tgl_lahir:'',
        tpt_lahir:'',
      },
      list_data: [],
      listKegiatan: [],

      page_limit: 10,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,

      UMUM: UMUM
    };
  },
  methods: {
    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_DESA_DATA_PEGAWAI + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
        //   authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jmlData;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },
    selectData : function(data){
            this.form.id = data.id;
 
            this.form.agama = data.agama
            this.form.agama_uraian = data.agama_uraian
            this.form.createdAt = data.createdAt
            this.form.createdBy = data.createdBy
            this.form.file = data.file
            this.form.fileThumb = data.fileThumb
            this.form.id = data.id
            this.form.jabatan = data.jabatan
            this.form.nama = data.nama
            this.form.nip = data.nip
            this.form.pangkat_gol = data.pangkat_gol
            this.form.pendidikan = data.pendidikan
            this.form.pendidikan_uraian = data.pendidikan_uraian
            this.form.tgl_lahir = data.tgl_lahir
            this.form.tpt_lahir = data.tpt_lahir
    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    },
    indexing: function(index) {
      var idx = (this.page_first - 1) * this.page_limit + index;
      return idx;
    },
    changeKategory(data){
      console.log(data)
      this.form.kategori = data
      this.getView()
    },
  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.cari_data();
  }
};
